export const ACCOUNT = 'account';
export const CARD = 'card';
export const PAYMENT = 'payment';
export const REWARDS = 'rewards';
